import React from 'react';
import Reveal from './Reveal';
import './Team.css';

const TEAM = [
  {
    name: 'Isaac Tetteh',
    role: 'Founder, CEO & Developer',
    theme: 'teal',
    text: 'Founded BikesDrop and personally built its platform, while driving product, technology and growth strategy from the ground up.',
  },
];

function initials(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}

export default function Team() {
  return (
    <section className="team section" id="team">
      <div className="container">
        <Reveal className="team__head">
          <span className="eyebrow eyebrow--teal">The Person Behind BikesDrop</span>
          <h2 className="section-heading">Meet the founder building Ghana&rsquo;s delivery network</h2>
          <p className="section-sub">
            Built from the ground up by its founder, driving product, technology and growth for the
            Ghanaian market.
          </p>
        </Reveal>

        <div className="team__grid">
          {TEAM.map((m, i) => (
            <Reveal delay={i * 70} className="team-card" key={m.name}>
              <div className={`team-card__avatar team-card__avatar--${m.theme}`}>{initials(m.name)}</div>
              <h3>{m.name}</h3>
              <span className={`pill pill--${m.theme}`}>{m.role}</span>
              <p>{m.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
